import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';

export default function SecureRoute() {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) { return;}

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return (<p>loading</p>);
  }

  return (<Outlet />);
}

//used with Okta to load the landing page. if not logged in, go to logged in page?